/* eslint-disable */

export interface DataPrecaptureWeiteresDto {
  betriebsNr?: string | null;
  auegZulassungSeit?: Date | null;
  auegZulassungBis?: Date | null;
  zustaendigePruefbehoerde?: string | null;
  betriebszweck?: number | null;
  handelsregisternummer?: string | null;
  sicherheitsbeauftragter?: string | null;
  tarifvertrag?: string | null;
  probezeitPersonal?: string | null;
  zahlungsbedingungen1Bis?: number | null;
  zahlungsbedingungen1Skonto?: number | null;
  zahlungsbedingungen2Bis?: number | null;
  zahlungsbedingungen2Skonto?: number | null;
  zahlungsbedingungen3Bis?: number | null;
  nummernkreisSachkontenVon?: number | null;
  nummernkreisSachkontenBis?: number | null;
  nummernkreisDebitorenKontenVon?: number | null;
  nummernkreisDebitorenKontenBis?: number | null;
  nummernkreisKreditorenKontenVon?: number | null;
  nummernkreisKreditorenKontenBis?: number | null;
  aueErloeskonto?: number | null;
  aueErloeskontoEg?: number | null;
  aueErloeskontoUstFrei?: number | null;
  freieRechnungenErloeskonto?: number | null;
  freieRechnungenErloeskontoEg?: number | null;
  freieRechnungenErloeskontoUstFrei?: number | null;
}

export const fixDataPrecaptureWeiteresDtoFromJson = (dto?: DataPrecaptureWeiteresDto | null): void => {
  if (!dto) {
    return;
  }
  dto.auegZulassungSeit = dto.auegZulassungSeit && new Date(dto.auegZulassungSeit);
  dto.auegZulassungBis = dto.auegZulassungBis && new Date(dto.auegZulassungBis);
};

export const fixDataPrecaptureWeiteresDtoToJson = (dto?: DataPrecaptureWeiteresDto | null): void => {
  if (!dto) {
    return;
  }
};
